import React from "react";
import Icons from "components/icons";
import Localize from "components/service/localize";
import "./user-status-badge.css";

const UserStatusBadge = ({ diamondStatus = false, bestSalesman = false, variant = "compact" }) => {
    if (!bestSalesman && !diamondStatus) return null;

    const award = bestSalesman && variant === "award";
    const label = bestSalesman
        ? (award ? "GLOBAL.Text_TopSalesman" : "GLOBAL.Text_BestSalesman")
        : "GLOBAL.Text_DiamondStatus";

    return (
        <div className={`user-status-badge${award ? " user-status-badge--award" : ""}`}>
            <Localize wrap>{label}</Localize>
            <span className="user-status-badge-icon" aria-hidden="true">
                {bestSalesman ? <Icons.BestSalesman /> : <Icons.Diamond />}
            </span>
        </div>
    );
};

export default UserStatusBadge;
